<section class="main-content wrapper content-padding " style="margin-top: 50px;">
    <div class="content-panel">

        <div class="tabs">
            <label class="tab">
                <a class="tab-link active-tab"> VALET PAGAMENTI</a>
            </label>
        </div>

        <div class="button-wrapper">
            <ng-template [ngIf]="selected == 'active'">
                <a class="btn hvr-grow has-margin-right" 
                    [routerLink]="['/expert/payments/storico']"
                    [queryParamsHandling]="'merge'"
                >
                    <i class="mr-10 far fa-folder"></i>Storico
                </a>
            </ng-template>
        
            <ng-template [ngIf]="selected == 'inactive'">
                <button class="btn hvr-grow has-margin-right" 
                    [routerLink]="['../']"
                    [queryParams]="{ navigation: 'back' }"
                    [queryParamsHandling]="'merge'"
                >
                    <i class="mr-10 fas fa-arrow-left"></i>Ritorna
                </button>
            </ng-template>
        </div>

        <div class="flex-container leggenda">
            <div class="item" *ngFor="let refundStatus of refundStatusAux[selected]">
                <span class="status {{refundStatusAux.css(refundStatus)}}"></span>
                {{ refundStatusAux.ln('it', refundStatus).toUpperCase() }}
            </div>
        </div>

        <p class="valet-name">
            <b>
                VALET
                <span *ngIf="selectedExpertId">| {{selectedValet?.user?.surname?.toUpperCase()}} {{selectedValet?.user?.name?.toUpperCase()}}</span>
            </b>
        </p>

        <div class="button-wrapper">
            <div class="grid-element">
                <label for="sku">VALETS</label>
                <select [(ngModel)]="selectedExpertId" (ngModelChange)="handleValetChange($event)" id="selezionePartner">
                    <option [ngValue]="null" disabled selected>Select Valet</option>
                    <option *ngFor="let expert of experts" [ngValue]="expert.id">{{expert.user.surname}} {{expert.user.name}}</option>
                </select>
            </div>

            <!--
            <div class="grid-element">
                <label for="sku">CUSTOM SEARCH</label>
                <input type="text" >  
            </div>
            -->
            
            <div class="grid-element" *ngIf="selected === 'active'">
                <label for="requestStatus">STATUS</label>
                <select [(ngModel)]="requestStatus" (ngModelChange)="handleRefundRequestChange()" id="requestStatus">
                    <option [ngValue]="null">Tutti</option>
                    <option *ngFor="let status of refundStatusAux[selected]" [ngValue]="status">
                    {{ refundStatusAux.ln('it', status) }}
                    </option>
                </select>
            </div>

        </div>

        <div class="column-box">
            <ng-container *ngIf="refundRequests?.length > 0; else noPayments">
                <div class="column-inner-other-user" *ngFor="let refundRequest of refundRequests, index as i"
                [ngClass]="{
                    'status-created-border': refundRequest.requestStatus === 'created',
                    'status-approved-border': refundRequest.requestStatus === 'approved',
                    'status-paid-border': refundRequest.requestStatus === 'paid'
                }"
                >
                    <div class="card-container" (click)="toggleAccordion(i)">
                        <div class="action-btns" 
                            [ngClass]="{
                                'status-created': refundRequest.requestStatus === 'created',
                                'status-approved': refundRequest.requestStatus === 'approved',
                                'status-paid': refundRequest.requestStatus === 'paid'
                            }"
                            >
                            <div class="action-title">
                                <h3>
                                    <b>ID CONSEGNA: #{{ refundRequest?.delivery.id }}</b>
                                </h3>
                            </div>
                            <div class="action-icons">
                                <i matTooltip="Approve" *ngIf="refundRequest.requestStatus != 'approved' && selected === 'active'" (click)="handleApproveClick(refundRequest, $event)" class="material-icons action-icon" style="color: #4CAF50;">
                                    check_circle
                                </i>
                                <i matTooltip="Paid" *ngIf="refundRequest.requestStatus != 'paid' && selected === 'active'" (click)="handlePaidClick(refundRequest, $event)" class="material-icons action-icon" style="color: #009688;">
                                    payments
                                </i>
                                <i class="material-icons" [ngClass]="{'rotate-icon': true, 'active': activeAccordionActivityIndex === i}">expand_more</i>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-body" *ngIf="activeAccordionActivityIndex === i">
                        <div class="info-container">
                            <div class="event-name">DELIVERY ID: {{ refundRequest?.delivery.id }}</div>
                            <span>
                                <b>PLUS VALUE: </b>€ {{ refundRequest?.plusValue || "---"}}
                                <br class="clear">
                            </span>
                            <span>
                                <b>REQUEST TEXT: </b>{{ refundRequest?.requestText || "---"}}
                                <br class="clear">
                            </span>
                            <span>
                                <b>RECEIPT: </b> 
                                <i
                                    matTooltip="Download Receipt"
                                    *ngIf="refundRequest?.receipt"
                                    class="material-icons action-icon"
                                    style="color: #2196F3; cursor: pointer; position: relative; top: 8px;"
                                    (click)="openReceiptInNewTab(refundRequest.receipt)"
                                    >
                                    download
                                </i>
                                <br class="clear">
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #noPayments>
                <span>NO PAYMENTS YET...</span>
            </ng-template>
        </div>
    </div>
</section>
